/* eslint-disable react/no-danger */
import { h } from 'preact'

export default function ArchiveDescription({ description }) {
	return <div className="archive-description" dangerouslySetInnerHTML={{ __html: description }} />
}
